import { ReorderItem, ReorderResult, TaskListItemTypes } from '@griply/types';

import { filterNewTaskChildIds } from './filter-new-task-child-ids';

export type OnTypeReorderOptions = {
  updatedItems: readonly ReorderItem[];
};

export const onTypeReorder = ({
  updatedItems,
}: OnTypeReorderOptions): ReorderResult => {
  const updatedSections: ReorderResult['updatedSections'] = [];

  updatedItems.forEach((item) => {
    if (item.type !== TaskListItemTypes.Type && !item.children) {
      return;
    }
    updatedSections.push({
      id: item.id,
      taskSorting: filterNewTaskChildIds(item.children),
    });
  });

  return { updatedSections, updatedTasks: [] };
};
